import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import { syncTwrDevicesByGroups } from '@app/actions/scenes/twrDevices/twrDevicesByGroups'
import { withAccessDenied, withProgressAndErrorMessage, withRefresh } from '@app/hocs'
import { isIOS } from 'react-device-detect'
import GroupsList
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/DevicesConditions/SelectDeviceCommon/Groups/GroupsList'
import GroupsListIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/DevicesConditions/SelectDeviceCommon/Groups/GroupsList'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? GroupsListIOS : GroupsList

const mapStateToProps = (state: AppState) => {
  const { isMobile } = state.mobileDetector
  const { groups } = state.scenes.twrDevicesByGroups
  const { deviceType } = state.scenes.currentSceneCreating.currentCondition
  return {
    deviceType,
    isMobile,
    groups,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  refresh: syncTwrDevicesByGroups,
  tryAgain: syncTwrDevicesByGroups,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const GroupsListEnhanced = enhance

export default GroupsListEnhanced
